require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-are-the-main-weaknesses-of-the-idb-invests-new.json") })
        }
      }, "path---en-us-update-what-are-the-main-weaknesses-of-the-idb-invests-new");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-are-the-main-weaknesses-of-the-idb-invests-new!./.cache/json/en-us-update-what-are-the-main-weaknesses-of-the-idb-invests-new.json
// module id = 830
// module chunks = 231608221292675